export type RuntimeFileName = 'ffmpeg-core.js' | 'ffmpeg-core.wasm';

export interface RuntimeManifest {
  version: 1;
  files: Record<RuntimeFileName, { digest: string; size: number }>;
}

export function validateRuntimeManifest(value: unknown): RuntimeManifest {
  const manifest = value as RuntimeManifest;
  for (const name of ['ffmpeg-core.js', 'ffmpeg-core.wasm'] as const) {
    const file = manifest?.files?.[name];
    if (
      manifest?.version !== 1 ||
      !/^[a-f0-9]{64}$/u.test(file?.digest ?? '') ||
      !Number.isSafeInteger(file?.size) ||
      file.size <= 0
    ) {
      throw new Error('Сервер вернул некорректный манифест видеодвижка.');
    }
  }
  return manifest;
}

export function runtimeAssetPath(manifest: RuntimeManifest, name: RuntimeFileName): string {
  return `/ffmpeg-core/${manifest.files[name].digest}/${name}`;
}
